import { apiClient } from './api';
import { Halter, HalterUpdateRequest, HalterCreateData } from '../types/halter';

export class HalterService {
  private static readonly BASE_URL = '/halter';

  static async updateHalter(id: number, updateData: HalterUpdateRequest): Promise<Halter> {
    const response = await apiClient.put(`${this.BASE_URL}/${id}`, updateData);
    return response.data;
  }

  static async getHalterById(id: number): Promise<Halter> {
    const response = await apiClient.get(`${this.BASE_URL}/${id}`);
    return response.data;
  }

  static async getHalterByZulassungsantragId(zulassungsantragId: number): Promise<Halter> {
    const response = await apiClient.get(`${this.BASE_URL}/zulassungsantrag/${zulassungsantragId}`);
    return response.data;
  }

  static async createHalter(halterData: HalterCreateData): Promise<Halter> {
    const response = await apiClient.post(this.BASE_URL, halterData);
    return response.data;
  }

  static async deleteHalter(id: number): Promise<void> {
    await apiClient.delete(`${this.BASE_URL}/${id}`);
  }
}
